<template>
  <footer class="main-footer">
    <div class="pull-right hidden-xs">
      <b>Version</b> 2.4.6
    </div>
    <strong>Copyright &copy; 2021-2022 <a href="https://adminlte.io">CRM</a>.</strong> All rights reserved.
  </footer>
</template>

<script>
export default {
  name: 'va-footer'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/VAFooter.vue